
import React from 'react';

const SpeakerIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M7 2v20h10V2H7zm8 2h-2v2h2V4zm-4 0H9v2h2V4zm4 4h-2v2h2V8zm-4 0H9v2h2V8zm4 4h-2v2h2v-2zm-4 0H9v2h2v-2zm4 4h-2v2h2v-2zm-4 0H9v2h2v-2zM7 20H5v-2h2v2zm12 0h-2v-2h2v2z" />
    <path d="M5 2h2v2H5V2zm12 0h2v2h-2V2zM5 20v2h2v-2H5zm12 0v2h2v-2h-2z" />
  </svg>
);

export default SpeakerIcon;
